<template>
    <v-container>
        <template>
            <v-row>
                <v-dialog v-model="previewPDFDialog" v-if="previewPDFDialog" fullscreen>
                    <v-card>
                        <v-toolbar
                            dark
                            color="primary"
                        >
                            <v-btn
                                icon
                                dark
                                @click="previewPDFDialog = false"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>Preview</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <PreviewPDF :filePath="previewFilePath" :loading="previewing" :isPDF="isPDF"> </PreviewPDF>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
        <v-data-table v-else
            :items="files"
            :items-per-page="20"
            :footer-props="{ 'items-per-page-options': [10,20,50,-1] }"
            :headers="mainHeaders"
            item-key="DocumentID"
            sort-by="DocumentID"
            :sort-desc="true">
            
        
            <template v-slot:header.Actions>
                <v-row justify="end">
                    <v-col cols="auto">
                        <AddFile v-if="canAddFiles"
                            ref="fileUpload" 
                            :allowedFileExtensions="allowedFileExtensions" 
                            @fileSelected="fileSelected" 
                            @fileInvalid="fileInvalid"
                            @save="saveFile"
                            :maxFileSizeMB="2" 
                        />
                    </v-col>
                </v-row>
            </template>
            
            <template v-slot:item.DocumentID="{ item }">
                <template v-if="item.DocumentID > 0">
                    <v-icon color="success">check</v-icon>
                </template>
                <template v-else>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon color="error"  dark v-bind="attrs" v-on="on">close</v-icon>
                        </template>
                        <div>File will be uploaded on saving the Medical Record</div>
                    </v-tooltip>
                </template>
            </template>
            
            <template v-slot:item.Actions="{ item }">
                <v-btn
                    v-if="item.S3Path"
                    color="info"
                    @click="preview(item.S3Path)">Preview</v-btn>
                <v-btn
                    v-if="!closedMedicalRecord"
                    color="error"
                    :loading="loading"
                    @click="deleteMedicalRecordReport(item)"
                >
                    Delete
                </v-btn>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import medicalRecordAPI from "../../services/medicalRecordAPI";
import fileService from "../../services/fileService";
import PreviewPDF from ".././venomanalysis/PreviewPDF"
import AddFile from "./AddFile.vue";

export default {

     components: {
        PreviewPDF,
        AddFile
    },
    props: {
        medicalRecordID: {
            type: String,
            default: ""
        },
        closedMedicalRecord: {
            type: Boolean,
            default:false
        },
        canAddFiles: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            previewing:false,
            previewPDFDialog:false,
            previewFilePath:"",
            isPDF:true,
            files: [],
            loadingError: "",
            deleteDialog:false,
            deleteItem:null,
            deleting:false,
            allowedFileExtensions: '.pdf',

            mainHeaders: [
                {
                    text: "Uploaded",
                    value: "DocumentID",
                    sortable: false,
                    class: "min-width-column"
                },
                {
                    text: "File Name",
                    value: "FileName"
                },
                {
                    text: "",
                    value: "Actions",
                    sortable: false,
                    class: "min-width-column"
                },
            ]
        };
    },
    computed:{
        permission:function(){
            return this.$store.state.authStore.user.UserProfile.Permissions.admin;
        }
    },
    methods: {
        fileSelected(file) {
            this.fileError = '';
            this.saveFile(file);
        },

        fileInvalid(errorMessage) {
            this.fileError = errorMessage;
            this.pendingFile = null;
        },
        saveFile(file) {
            this.files.push(file);
            this.$emit('addFile', file);
        },
        deleteFile(file) {
            const removingIndex = this.files.indexOf(file);
            this.files.splice(removingIndex, 1);

            this.$emit('removeFile', file);
        },
        async preview(s3Path) {

            this.previewPDFDialog = true;
            if(!(s3Path.toLowerCase().includes("pdf"))){
                this.previewFilePath = "";
                this.isPDF = false;
            }
            else{

                this.isPDF = true;
                this.previewing = true;

                var filePath = await fileService.getDownloadURL(s3Path);
                
                this.previewing = false;
                this.previewFilePath = filePath; 
            }
                   
        },
        async deleteMedicalRecordReport(item) {
            this.loading = true;
            this.loadingError = "";

            if(item.DocumentID > 0 ) {
                try {
                    await medicalRecordAPI.deleteMedicalRecordReport(item.DocumentID);
                } catch (e) {
                    this.loadingError = e.message
                }
                this.loadFiles();
            }
            else {
                const removingIndex = this.files.indexOf(item);
                this.files.splice(removingIndex, 1);
                
                this.$emit('removeFile', item);
            }

            this.loading = false;
        },
        async loadFiles() {
            this.loading = true;
            this.loadingError = "";

            if(this.medicalRecordID){
                try {
                    this.files = await medicalRecordAPI.getMedicalRecordDocuments(this.medicalRecordID);
                    this.expanded = [ this.files[0] ]
                } catch (e) {
                    this.loadingError = e.message
                }
            }

            this.loading = false;
            
        },
},

async created() {
        await this.loadFiles();
},

}
</script>

<style>
    .min-width-column {
        width: 1%;
    }
</style>

<style scoped>
    .expansion-panel {
        background-color: white;
    }
</style>